module.exports = __webpack_public_path__ + "img/icona_live_tv.057ec179.png";